import { ProductAPI } from '../lib/api';
import { dateFields } from "../lib/ui";

export default async function searchBar() {

  /** Tour start date field */
  const input = document.getElementById('products-tourStartDate');
  dateFields([input], {
    change: (s, d, i) => { /* ? */ }
  });

  /** People inputs */
  const peopleInputs = document.querySelectorAll('input.person-input');
  peopleInputs.forEach(peopleInput => {
    
    let template = peopleInput.value.replace(/[0-9]/g, '');
    peopleInput.addEventListener('keydown', event => {
      let code = (event.which) ? event.which : event.keyCode
      if ((code >= 48 && code <= 57) || (code >= 96 && code <= 105)) { 
        // carry on
      } else {
        event.preventDefault();
      }
      if (code === 13) {
        peopleInput.blur();
      }
    });
    peopleInput.addEventListener('focusin', event => {
      event.target.value = '';
    });
    peopleInput.addEventListener('focusout', event => {
      let fn = event.target.getAttribute("name");
      if (event.target.value === '') {
        event.target.value = (fn === 'adults') ? '1' : '0';
      }
      event.target.value = `${event.target.value}${template}`;
    });
  });

  /** 
   * Autocomplete
   */
  const searchBars = document.querySelectorAll('.product-search-bar');
  let searchTerms = null;
  const getSearchTerms = async () => {
    if (!searchTerms) {
      const API = new ProductAPI();
      let response = await API.getProductTitles();

      if (response.status === 200 && response.data) { 
        searchTerms = response.data;
      }
    }
    return searchTerms;
  }

  const terms = await getSearchTerms();

  searchBars.forEach((bar) => {
    const autoResults = bar.querySelector('[data-pre-populate-results]');

    if (!autoResults) {
      return;
    }

    const searchForm = bar.querySelector('form');
    const searchInput = bar.querySelector('[data-pre-populate-input]');
    const autoResultsList = autoResults.querySelector('ul');
    const autoSuggest = async () => {
    
      if (terms) {
        const completeMatch = (input) => {
          if (input == '') return [];
          let reg = new RegExp(input, "i");
          return terms.filter((term) => {
            if (term.match(reg)) return term;
          });
        }

        const selectSuggestion = value => {
          clearAutoResults();
          autoResults.style.display = 'none';
          searchInput.value = value;
        }

        const clearAutoResults = () => {
          autoResultsList.innerHTML = '';
        }

        searchInput.addEventListener('keyup', event => {
          const searchInputValue = event.target.value;
          clearAutoResults();
          if (searchInputValue.length > 2) {
            let terms = completeMatch(searchInputValue);
            if (terms.length > 0) {
              terms.forEach(term => {
                const node = document.createElement("li");
                const textnode = document.createTextNode(term);
                node.addEventListener('click', event => {
                  selectSuggestion(term);
                  searchForm.submit();
                });
                node.appendChild(textnode);
                autoResultsList.appendChild(node);
              });
            } else {
              const node = document.createElement("li");
              const textnode = document.createTextNode(`Search for ${searchInputValue}`);
              node.addEventListener('click', _ => searchForm.submit());
              node.appendChild(textnode);
              autoResultsList.appendChild(node);
            }

            autoResults.style.display = 'block';
          } else {
            autoResults.style.display = 'none';
          }
        });
      }
    }
    autoSuggest();
  });
}



// WEBPACK FOOTER //
// ./source/scripts/products/actions/searchBar.js